const URL = '/sucursales';

const state = {
  all: [],
  selected: {
    id: null,
    abreviatura: null,
    nombre: null,
  },
  loading: false
}

// GETTERS
const getters = {
  all (state) {
    return state.all
  },
  selected (state) {
    return state.selected
  },
  loading (state) {
    return state.loading
  }
}

// ACTIONS
const actions = {
  onClearSelected ({ commit }) {
    commit('setSelected', {
      id: null,
      abreviatura: null,
      nombre: null,
    })
  },
  onFetch ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      window.axios.get(URL)
        .then(response => {
          commit('setAll', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  }
}

// MUTATIONS
const mutations = {
  setAll (state, payload) {
    state.all = payload.slice()
  },
  setSelected (state, payload) {
    state.selected = payload
  },
  setLoading (state, payload) {
    state.loading = payload
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
